import classNames from 'classnames'
import React, { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import styles from './FormControl.module.css'

type Props = {
  children: React.ReactNode
  className?: string
  error: boolean
  required: boolean
  disabled: boolean
} & ComponentPropsWithoutRef<'div'>

export const FormControl: FunctionComponent<Props> = ({
  children,
  className,
  error,
  required,
  disabled,
  ...rest
}: Props) => (
  <div
    {...rest}
    className={
      classNames(
        className,
        styles.FormControl,
        {
          [styles.Disabled]: disabled,
          [styles.Error]: error,
          [styles.Required]: required,
        },
      )
    }
  >
    {children}
  </div>
)
